import { createContext } from "react";

import type { MembershipProductEvaluationStateType } from "~/clientState/providers/acquisition/MembershipProductEvaluation/types";
import { MembershipProductEvaluationCode } from "~/generated/graphql";

export const MembershipProductEvaluationStateContext =
  createContext<MembershipProductEvaluationStateType>({
    membershipEvaluationCode: MembershipProductEvaluationCode.NoRisk,
    paymentInstrumentToken: "",
    creditCardBin: "",
  });
